/**
 * @author shao
 * @date 2018/12/5
 * @project kaoshizhongxin
 * @quote @quote https://github.com/simplesmiler/vue-clickaway/blob/master/index.js
 */
import Vue from 'vue'

const HANDLER = `_onoutsideEvent_`
const DIRECTIVE_NAME = `onoutside`

const warn = Vue.util.warn
const dom = document.documentElement

const bind = (el, binding, vnode) => {
  unbind(el)
  let callback = binding.value
  if (typeof callback !== 'function') {
    warn(
      'v-' + binding.name + '="' +
      binding.expression + '" expects a function value, ' +
      'got ' + callback
    )
    return
  }
  // 参考 https://github.com/simplesmiler/vue-clickaway/blob/master/index.js
  let initialMacrotaskEnded = false
  setTimeout(() => {
    initialMacrotaskEnded = true
  }, 0)
  el[HANDLER] = {
    name: binding.arg || 'click',
    callback (e) {
      // 参考 https://github.com/simplesmiler/vue-clickaway/blob/master/index.js
      let path = e.path || (e.composedPath ? e.composedPath() : null)
      if (initialMacrotaskEnded && (path ? path.indexOf(el) < 0 : (e.target !== el && !el.contains(e.target)))) {
        return binding.value.call(vnode.context, e)
      }
    }
  }
  dom.addEventListener(el[HANDLER].name, el[HANDLER].callback, false)
}

function unbind (el) {
  if (el[HANDLER]) {
    dom.removeEventListener(el[HANDLER].name, el[HANDLER].callback, false)
    delete el[HANDLER]
  }
}

function update (el, binding, vnode) {
  if (binding.value === binding.oldValue) return
  bind(el, binding, vnode)
}

const plugin = {
  name: DIRECTIVE_NAME,
  install (Vue) {
    Vue.directive(DIRECTIVE_NAME, {
      bind,
      unbind,
      update
    })
  }
}

export default plugin
